import axios from './util/axios.js'

export function getReportReasons () {
  return axios.get('/api/community/reports/reasons/')
}

export function getReports () {
  return axios.get('/api/community/reports/')
}

export function postReport ({ contentType, contentId, reportedClient, reason, details }) {
  return axios.post('/api/community/reports/', {
    contentType,
    contentId,
    reportedClient,
    reason,
    details
  })
}
